import { PurchaseOrderItem, PurchaseOrderTemplate } from './purchaseOrder';

export interface GoodsReceipt {
  id: string;
  receiptNumber: string;
  purchaseOrderId: string;
  warehouseId: string;
  templateId?: string | null;
  receivedDate: string;
  receivedBy: string;
  status: GoodsReceiptStatus;
  notes?: string | null;
  companyId: string;
  createdAt: string;
  updatedAt: string;
  purchaseOrder?: {
    id: string;
    poNumber: string;
    vendor?: {
      id: string;
      name: string;
      email?: string;
      phone?: string;
    };
    items?: PurchaseOrderItem[];
  };
  warehouse?: {
    id: string;
    code: string;
    name: string;
    address?: string;
  };
  template?: PurchaseOrderTemplate | null;
  items?: GoodsReceiptItem[];
}

export interface GoodsReceiptItem {
  id: string;
  receiptId: string;
  poItemId: string;
  productId: string;
  quantityReceived: number;
  quantityRejected: number;
  serialNumbers?: string | null;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
  product?: {
    id: string;
    name: string;
    sku: string;
  };
  poItem?: PurchaseOrderItem;
}

export type GoodsReceiptStatus = 'DRAFT' | 'POSTED' | 'CANCELLED';

export interface CreateGoodsReceiptData {
  purchaseOrderId: string;
  warehouseId: string;
  templateId?: string;
  receivedDate?: string;
  receivedBy: string;
  items: CreateGoodsReceiptItemData[];
  notes?: string;
}

export interface CreateGoodsReceiptItemData {
  poItemId: string;
  quantityReceived: number;
  quantityRejected?: number;
  serialNumbers?: string;
  notes?: string;
}

export interface GoodsReceiptFilters {
  page?: number;
  limit?: number;
  purchaseOrderId?: string;
  warehouseId?: string;
  search?: string;
  status?: GoodsReceiptStatus;
}

export interface GoodsReceiptsResponse {
  goodsReceipts: GoodsReceipt[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
  };
}

export const GOODS_RECEIPT_STATUS_LABELS: Record<GoodsReceiptStatus, string> = {
  DRAFT: 'Draft',
  POSTED: 'Posted',
  CANCELLED: 'Cancelled'
};

export const GOODS_RECEIPT_STATUS_COLORS: Record<GoodsReceiptStatus, string> = {
  DRAFT: 'bg-gray-100 text-gray-800',
  POSTED: 'bg-green-100 text-green-800',
  CANCELLED: 'bg-red-100 text-red-800'
};
